import React from "react";

const FormHead = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  const handleStep1 = () => {
    if (
      document
        .getElementById("step-1-indicator")
        .classList.contains("finished-step")
    ) {
      props.ToggleStep1();
      setTimeout(() => {
        updateNextButtonState();
      }, 100);
    }
  };
  const handleStep2 = () => {
    if (
      document.getElementById("next-btn").classList.contains("disabled-action")
    ) {
      return null;
    } else {
      document.getElementById("next-btn").click();
    }
  };
  const updateNextButtonState = () => {
    if (
      document.getElementById("title").value.length > 0 &&
      document.getElementById("selected-start-date").innerHTML !== "Start Date"
    ) {
      document.getElementById("next-btn").classList.remove("disabled-action");
    } else {
      document.getElementById("next-btn").classList.add("disabled-action");
    }
  };
  return (
    <React.Fragment>
      <section className="form-head">
        <i className="feather-arrow-left" onClick={() => props.GoBack()}></i>
        <h1 id="jpa-title-text">{props.HeadText}</h1>
        <section className="form-actions">
          <span className="secondary-action" onClick={() => props.GoBack()}>
            {translateText("cancel")}
          </span>
        </section>
      </section>
      <section className="step-indicator">
        <div
          className="step-item active-step"
          id="step-1-indicator"
          onClick={() => handleStep1()}
        >
          <div className="indicator"></div>
          <div className="step-info">
            <span className="radio">
              <i className="feather-check"></i>
            </span>
            <p>{translateText("core_info")}</p>
          </div>
        </div>
        <div
          className="step-item"
          id="step-2-indicator"
          onClick={() => handleStep2()}
        >
          <div className="indicator"></div>
          <div className="step-info">
            <span className="radio">
              <i className="feather-check"></i>
            </span>
            <p>{translateText("recom_criteria")}</p>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default FormHead;
